import { ILocation } from "./general.model";

export type HotspotVideoWall = "right" | "left" | "front" | "back";

export interface IHotspot {
  id: string;
  type: hotspotType;
  position: ILocation;
  rotation: ILocation;
  scale: number;
  action: any;
  videoSrc?: string;
  videoWall?: HotspotVideoWall;
  title: string;
}

export enum hotspotType {
  MOVEMENT = "movement",
  ARROW = "arrow",
  INFO = "info",
  INFOPRODUCT = "info-product",
  COMINGSOON = "coming-soon",
}
